import { Outlet } from 'react-router-dom';

import AssetsSidebar from './components/AssetsSidebar';

const Assets = () => {
  return (
    <div className="flex h-full overflow-hidden bg-neutral-50" data-dd-privacy="allow">
      <AssetsSidebar />
      <div className="flex w-full flex-col">
        <Outlet />
      </div>
    </div>
  );
};

export default Assets;
